"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyleUtils = exports.shownStyles = exports.hiddenStyles = exports.responsiveExpandedStyles = exports.expandedStyles = exports.responsiveCollapsedStyles = exports.collapsedStyles = void 0;
exports.collapsedStyles = {
    visibility: 'hidden !important',
    overflow: 'hidden !important',
    height: '0 !important',
    width: '0 !important',
    'min-width': '0 !important',
    'min-height': '0 !important',
    'margin-bottom': '0 !important',
    'margin-left': '0 !important',
    'margin-right': '0 !important',
    padding: '0 !important',
};
exports.responsiveCollapsedStyles = {
    ...exports.collapsedStyles,
    position: 'absolute !important',
    'margin-top': '0 !important',
};
exports.expandedStyles = {
    visibility: null,
    overflow: null,
    height: null,
    width: null,
    'min-width': null,
    'min-height': null,
    'margin-bottom': null,
    'margin-left': null,
    'margin-right': null,
    padding: null,
};
exports.responsiveExpandedStyles = {
    ...exports.expandedStyles,
    position: null,
    'margin-top': null,
};
exports.hiddenStyles = {
    visibility: 'hidden !important',
};
exports.shownStyles = {
    visibility: null,
};
const createStyleUtils = ({ isResponsive }) => {
    return {
        getCollapsedStyles: () => (isResponsive ? exports.responsiveCollapsedStyles : exports.collapsedStyles),
        getExpandedStyles: () => (isResponsive ? exports.responsiveExpandedStyles : exports.expandedStyles),
        getHiddenStyles: () => exports.hiddenStyles,
        getShownStyles: () => exports.shownStyles,
    };
};
exports.createStyleUtils = createStyleUtils;
//# sourceMappingURL=styleUtils.js.map